import clsx from "clsx";
import { ReactNode } from "react";
import dayjs, { type Dayjs } from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

interface IProps {
  time: string | Date | Dayjs;
  className?: string;
  showHour?: boolean;
  isRelative?: boolean;
  children?: ReactNode;
}

export function Timestamp({ time, className, isRelative = false, showHour = false, children }: IProps) {
  if (time === null) {
    return;
  }

  let dateTime = dayjs(time);
  let template = showHour ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD";
  let formatted = isRelative ? dateTime.fromNow() : dateTime.format(template);

  return (
    <time className={clsx("timestamp", className)} dateTime={time.toString()} title={time.toString()}>
      {children ?? formatted}
    </time>
  );
}
